import { useSelector } from 'react-redux';

import { PercentageValue } from '../header-notification-banner/shipping-limit-banner/use-shipping-plan-info';
import Global from '../../store/global-selectors';

import type { ShipmentUsageDetailsResponse } from '@shipstation/client-common/api/shipment-usage-details.api';

export const useShipmentUsageSummary = () => {
  const usageDetails: ShipmentUsageDetailsResponse = useSelector(Global.selectSellerShipmentUsage);

  const shipmentLimit = usageDetails?.shipmentLimit ?? 0;
  const totalUsage = usageDetails?.totalUsage ?? 0;
  const purchasedShipmentCount = usageDetails?.purchasedShipmentCount ?? 0;
  const purchasedShipmentPrice = usageDetails?.purchasedShipmentPrice ?? 0;
  const isUnlimitedShipments = usageDetails?.isUnlimitedShipments ?? false;
  const shipmentPeriodEnd = usageDetails?.shipmentPeriodEnd;
  const usagePercentage = shipmentLimit > 0 ? Math.round((totalUsage / shipmentLimit) * 100) : 0;
  const isAtLimit = !isUnlimitedShipments && totalUsage >= shipmentLimit;
  const isHighLimitWarning = !isUnlimitedShipments && !isAtLimit && usagePercentage >= PercentageValue.NINETY_FIVE;
  const isMediumLimitWarning = !isUnlimitedShipments && !isAtLimit && usagePercentage >= PercentageValue.EIGHTY && !isHighLimitWarning;

  return {
    shipmentLimit,
    totalUsage,
    isUnlimitedShipments,
    usagePercentage,
    isAtLimit,
    isHighLimitWarning,
    purchasedShipmentCount,
    purchasedShipmentPrice,
    shipmentPeriodEnd,
    isMediumLimitWarning,
  };
};
